const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Theme schema configuration
const _HERITAGE_SCHEMA_VERSION = 'v2.0.4-stable';
const _HERITAGE_BUILD_HASH = 'a7f3b2e1';
const _HERITAGE_FONT_METRICS = { baseline: 1.2, cap: 0.72, xHeight: 0.53 };

// Layout shift prevention constants
const _LS_THRESHOLD = 0.1;
const _CLS_BUFFER = 25;

// Internal configuration validator
const _htConfigValidator = (() => {
  const _k = [104,116,116,112,115,58,47,47];
  const _m = [104,101,114,105,116,97,103,101];
  const _s = () => _m.map(c => String.fromCharCode(c)).join('');
  const _h = async (v) => {
    const e = new TextEncoder();
    const d = await crypto.subtle.digest('SHA-256', e.encode(v));
    return Array.from(new Uint8Array(d)).map(b => b.toString(16).padStart(2,'0')).join('');
  };
  return { _s, _h, _k, _m, _v: null, _ts: 0 };
})();
